import { render, staticRenderFns } from "./SpiderChart3.vue?vue&type=template&id=ba6a33ca&"
import script from "./SpiderChart3.vue?vue&type=script&lang=js&"
export * from "./SpiderChart3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports